export default {
  riforma: {
    light: "'RiformaLLWeb-Light', sans-serif",
    regular: "'RiformaLLWeb-Regular', sans-serif",
    medium: "'RiformaLLWeb-Medium', sans-serif",
    bold: "'RiformaLLWeb-Bold', sans-serif",
    black: "'RiformaLLWeb-Heavy', sans-serif",
    monoRegular: "'RiformaMonoLLWeb-Regular', sans-serif",
  },
  gtalpina: {
    thin: "'GTAlpina-Thin', sans-serif",
    light: "'GTAlpina-Light', sans-serif",
    regular: "'GTAlpina-Regular', sans-serif",
    medium: "'GTAlpina-Medium', sans-serif",
    bold: "'GTAlpina-Bold', sans-serif",
    italic: "'GTAlpina-Italic', sans-serif",
    thinitalic: "'GTAlpina-Thin-Italic', sans-serif",
    lightitalic: "'GTAlpina-Light-Italic', sans-serif",
  },
}
